export const findFactura =  (name) => {
    return new Promise((resolve,reject) => {
        const myHeaders = new Headers();
    
        var requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow'
        };
    
        fetch(`https://conta-api.solucioneskmp.com/Facturas/getFiles/${name}`, requestOptions)
          .then(response => response.json())
          .then(result => resolve(result))
          .catch(error => reject( error));
    })}